export default __webpack_public_path__ + "static/stars-a4a290f89eac631d1b00977b9383c770.png";